import { ImageList, ImageListItem } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'

import { VendorAward } from '@f-fertighaus/applications/Next/types/vendorResponse'

interface VendorAwardsProps {
  vendorAwards: VendorAward[]
}

const StyledImageList = styled(ImageList)(({ theme }) => ({
  gridAutoFlow: 'column',
  gridAutoColumns: 'minmax(100px, 1fr)',
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    '&::-webkit-scrollbar': { width: '0' },
    marginBottom: theme.spacing(2)
  }
}))

export const VendorAwards = ({ vendorAwards }: VendorAwardsProps) => (
  <StyledImageList gap={16}>
    {vendorAwards.map(award => (
      <ImageListItem key={award['max-250x250']}>
        <img
          src={award['max-250x250']}
          alt='vendor-award'
          loading='lazy'
          style={{
            width: 100,
            height: 100,
            maxWidth: 'initial',
            objectFit: 'contain'
          }}
        />
      </ImageListItem>
    ))}
  </StyledImageList>
)
